// extracted by mini-css-extract-plugin
export var divider = "_m5-0";
export var systemMessage = "_m5-1";